import { Option, StepperConfig } from "src/types/common";
import { path } from "./path";

export const indexing = [
  "1st",
  "2nd",
  "3rd",
  "4th",
  "5th",
  "6th",
  "7th",
  "8th",
  "9th",
  "10th",
];

export const OtpType = {
  EMAIL: "EMAIL",
  AADHAAR: "AADHAAR",
  MOBILE: "MOBILE",
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
};

export const USER_TYPE2 = {
  INDIVIDUAL: "INDIVIDUAL",
  ENTITY: "ORGANIZATION",
  IMPLEMENTING_OFFICER: null,
};

export const devTypes = {
  INDIVIDUAL: "INDIVIDUAL",
  ORGANIZATION: "ORGANIZATION",
  OTHER: "OTHER",
};

export const ownerShipRecordtype = {
  "03790557-5c1f-4441-8bda-9304374865c0": "NOC",
  "fb2c6d5d-3265-4539-a180-bfde07748eed": "Lease",
};

export const SidebarMenu = [
  {
    icon: "/assets/svg/homeIcon.svg",
    iconSelected: "/assets/svg/homeIcon.svg",
    text: "Home",
    path: `/user-home`,
    id: "Dashboard",
    type: [USER_TYPE2.ENTITY],
  },
  {
    icon: "/assets/svg/marketIcon.svg",
    iconSelected: "/assets/svg/marketIcon.svg",
    text: "DashBoard",
    path: `/market-watch`,
    id: "Dashboard",
    type: [
      USER_TYPE2.INDIVIDUAL,
      USER_TYPE2.ENTITY,
      USER_TYPE2.IMPLEMENTING_OFFICER,
    ],
  },

  // {
  //   icon: "/assets/svg/marketIcon.svg",
  //   iconSelected: "/assets/svg/selectedFolderIcon.svg",
  //   text: "Register New Eco-Restoration Block",
  //   id: "Registered",
  //   type: [USER_TYPE2.IMPLEMENTING_OFFICER],
  // },

  {
    icon: "/assets/svg/folderIcon.svg",
    iconSelected: "/assets/svg/selectedFolderIcon.svg",
    text: "Eco-Restoration Blocks",
    path: "/",
    id: "my-projects",
    type: [USER_TYPE2.INDIVIDUAL, USER_TYPE2.IMPLEMENTING_OFFICER],
  },
  {
    icon: "/assets/svg/folderIcon.svg",
    iconSelected: "/assets/svg/selectedFolderIcon.svg",
    path: "/",
    text: "Selected Under Old modilites",
    id: "select-eco-block",
    type: [USER_TYPE2.ENTITY],
    showForNewEntity: false, // 👈 only for new entities if you want
    isAction: true, // 👈 identifies it as a button
  },
  // {
  //   icon: "/assets/svg/folderIcon.svg",
  //   iconSelected: "/assets/svg/selectedFolderIcon.svg",
  //   text: "Selected",
  //   path: "/",
  //   id: "my-projects",
  //   type: [USER_TYPE2.ENTITY],
  // },

  {
    icon: "/assets/svg/folderIcon.svg",
    iconSelected: "/assets/svg/selectedFolderIcon.svg",
    text: "Select Eco-Restoration Blocks",
    id: "select-land-parcels",
    path: "/land-parcel-selection",
    type: [USER_TYPE2.ENTITY],
    showForNewEntity: true,
  },
  {
    icon: "/assets/svg/folderIcon.svg",
    iconSelected: "/assets/svg/selectedFolderIcon.svg",
    text: "Selected",
    id: "selected",
    path: "/selected",
    type: [
      USER_TYPE2.INDIVIDUAL,
      USER_TYPE2.ENTITY,
      USER_TYPE2.IMPLEMENTING_OFFICER,
    ],
    showForNewEntity: true,
  },
  {
    icon: "/assets/svg/folderIcon.svg",
    iconSelected: "/assets/svg/selectedFolderIcon.svg",
    text: "Detailed Project Report",
    id: "detailed-project-report",
    path: "/detailed-project-report",
    type: [
      USER_TYPE2.INDIVIDUAL,
      USER_TYPE2.ENTITY,
      USER_TYPE2.IMPLEMENTING_OFFICER,
    ],
    showForNewEntity: true,
  },
  {
    icon: "/assets/svg/folderIcon.svg",
    iconSelected: "/assets/svg/selectedFolderIcon.svg",
    text: "Memorandum Of Understanding",
    path: "/Memorandum",
    id: "memorandum-of-understanding",
    type: [
      USER_TYPE2.INDIVIDUAL,
      USER_TYPE2.ENTITY,
      USER_TYPE2.IMPLEMENTING_OFFICER,
    ],
    showForNewEntity: true,
  },
  {
    icon: "/assets/svg/folderIcon.svg",
    iconSelected: "/assets/svg/selectedFolderIcon.svg",
    text: "Payment",
    path: "/payment",
    id: "payment",
    type: [
      USER_TYPE2.INDIVIDUAL,
      USER_TYPE2.ENTITY,
      USER_TYPE2.IMPLEMENTING_OFFICER,
    ],
    showForNewEntity: true,
  },

  {
    icon: "/assets/svg/folderIcon.svg",
    iconSelected: "/assets/svg/selectedFolderIcon.svg",
    text: "Demand Notes and Admin Fee",
    path: "/demand-notes",
    id: "my-projects",
    type: [USER_TYPE2.ENTITY],
    showForNewEntity: true,
  },
  {
    icon: "/assets/svg/folderIcon.svg",
    iconSelected: "/assets/svg/selectedFolderIcon.svg",
    text: "Annual Work Report",
    path: "/annual-work",
    id: "my-projects",
    type: [USER_TYPE2.ENTITY],
    showForNewEntity: true,
  },
  // {
  //   icon: "/assets/svg/folderIcon.svg",
  //   iconSelected: "/assets/svg/selectedFolderIcon.svg",
  //   text: "Selected Blocks",
  //   path: "/Memorandum",
  //   id: "my-projects",
  //   type: [USER_TYPE2.ENTITY],
  //   showForNewEntity: true,
  // },
  {
    icon: "/assets/svg/bookIcon.svg",
    iconSelected: "/assets/svg/bookIcon.svg",
    text: "Cost Estimation",
    path: `/order-book`,
    id: "order-book",
    type: [USER_TYPE2.INDIVIDUAL, USER_TYPE2.IMPLEMENTING_OFFICER],
    // renders a non-clickable section heading above this item in the sidebar
    sectionLabel: "Old Modalities",
  },
  {
    icon: "/assets/svg/bookIcon.svg",
    iconSelected: "/assets/svg/bookIcon.svg",
    text: "Fund Application",
    path: `/fund-application`,
    id: "raise-fund",
    type: [
      USER_TYPE2.INDIVIDUAL,
      USER_TYPE2.ENTITY,
      USER_TYPE2.IMPLEMENTING_OFFICER,
    ],
    showForNewEntity: false,
  },
  {
    icon: "/assets/svg/folderIcon.svg",
    iconSelected: "/assets/svg/selectedFolderIcon.svg",
    text: "Progress Details",
    path: "/Demo",
    options: [
      {
        icon: "/assets/svg/bookIcon.svg",
        iconSelected: "/assets/svg/bookIcon.svg",
        text: "Digital Cost Estimate",
        path: `/cost-estimate-digital`,
        id: "cost-estimate-details",
        type: [USER_TYPE2.IMPLEMENTING_OFFICER],
      },
      {
        icon: "/assets/svg/bookIcon.svg",
        iconSelected: "/assets/svg/bookIcon.svg",
        text: "Update Progress",
        path: `/update-progress-details`,
        id: "update-progress-details",
        type: [USER_TYPE2.INDIVIDUAL, USER_TYPE2.IMPLEMENTING_OFFICER],
      },
    ],
    id: "progress-details",
    type: [USER_TYPE2.INDIVIDUAL, USER_TYPE2.IMPLEMENTING_OFFICER],
  },
  {
    icon: "/assets/svg/bookIcon.svg",
    iconSelected: "/assets/svg/bookIcon.svg",
    text: "Progress Details",
    path: `/update-progress-details`,
    id: "update-progress-details",
    type: [USER_TYPE2.ENTITY],
    // showForNewEntity: true,
    showForNewEntity: false,
  },
  {
    icon: "/assets/svg/bookIcon.svg",
    iconSelected: "/assets/svg/bookIcon.svg",
    text: "Monitoring",
    path: `/monitoring`,
    id: "Monitoring",
    type: [USER_TYPE2.INDIVIDUAL, USER_TYPE2.IMPLEMENTING_OFFICER],
  },
  {
    icon: "/assets/svg/bookIcon.svg",
    iconSelected: "/assets/svg/bookIcon.svg",
    text: "Monitoring",
    path: `/monitoring`,
    id: "Monitoring",
    type: [USER_TYPE2.ENTITY],
    // showForNewEntity: true,
    showForNewEntity: false,
  },
  {
    icon: "/assets/svg/portfolioIcon.svg",
    iconSelected: "/assets/svg/portfolioIcon.svg",
    text: "Implementing Officer",
    path: `/add-implementing-officer`,
    id: "implementing-officer",
    type: [USER_TYPE2.INDIVIDUAL],
  },
];

export const helper = [
  {
    label: "Green Credit Project Developer",
    value: "greenCreditProjectDeveloper",
  },
];

export const userTypeOptions = [
  {
    label: "Green Credit Project Developer",
    value: "greenCreditProjectDeveloper",
  },
  { label: "Certifiers", value: "certifier" },
  { label: "Verifiers", value: "verifier" },
  { label: "Buyers", value: "buyers" },
];

export const DOCUMENT_ENUM = {
  CIN: "CIN",
  AADHAAR: "AADHAAR",
  GST: "GST",
  PAN: "PAN",
};

export enum PROJECT_TYPE {
  LAND_LEASED = "LAND_LEASED",
  TREE_PLANTATION = "TREE_PLANTATION",
}
export enum PROJECT_TYPE_STRING {
  LAND_LEASED = "Land Leased",
  TREE_PLANTATION = "Tree Plantation",
}

export enum PROJECT_STATUS {
  DRAFT = "In Review",
  IMAGE_PENDING = "Image Pending",
  DECLARATION_PENDING = "Declaration Pending",
  VERIFICATION_PENDING = "Verification Pending",
  REVIEWED = "Reviewed",
  REVIEW_FAILED = "Review Failed",
  COMPLETED = "Completed",
  APPROVED = "Approved",
  REJECTED = "Rejected",
  FLAGGED = "Flagged",
}

export enum CHIP_STATUS {
  DRAFT = "draft",
  IMAGE_PENDING = "inactive",
  DECLARATION_PENDING = "draft",
  VERIFICATION_PENDING = "draft",
  REVIEWED = "active",
  REVIEW_FAILED = "error",
  COMPLETED = "active",
  APPROVED = "active",
  REJECTED = "error",
  FLAGGED = "inactive",
}

export const reason = {
  REJECTED: {
    heading: "Reason For Rejection",
    text: "Text for reason",
  },
};

export enum DECLERATION_TYPE {
  COMPLIANCE = "COMPLIANCE",
  VOLUNTARY = "VOLUNTARY",
  ACA = "ACA",
}
export enum SPECIES_TYPE {
  FORESTRY_SPECIES = "FORESTRY_SPECIES ",
  HORTICULTURE_SPECIES = "HORTICULTURE_SPECIES",
}

export const declerationTypeOptions = [
  {
    label: "Voluntary",
    value: DECLERATION_TYPE.VOLUNTARY,
  },
  {
    label: "Compliance",
    value: DECLERATION_TYPE.COMPLIANCE,
  },
  {
    label: "ACA",
    value: DECLERATION_TYPE.ACA,
  },
];
export const speciesTypeOptions = [
  {
    label: "FORESTRY SPECIES",
    value: SPECIES_TYPE.FORESTRY_SPECIES,
  },
  {
    label: "HORTICULTURE SPECIES",
    value: SPECIES_TYPE.HORTICULTURE_SPECIES,
  },
];

export const USER_TYPE = {
  INDIVIDUAL: "INDIVIDUAL",
  ENTITY: "ORGANIZATION",
};

export const documentUpload = [
  {
    label: "CIN/GSTIN UIN",
    value: DOCUMENT_ENUM.CIN,
  },
  {
    label: "PAN",
    value: DOCUMENT_ENUM.PAN,
  },
];

export const devTypeOptions = [
  {
    label: "Forest Department",
    value: USER_TYPE.INDIVIDUAL,
  },
  { label: "Entity/Private Sector/Philanthropy", value: USER_TYPE.ENTITY },
];

export const countryCode = [
  {
    label: "+91",
    value: "+91",
  },
];

export const rainFallZoneOption = [
  {
    label: "500-1000mm",
    value: "500-1000mm",
  },
  {
    label: "200-600mm",
    value: "200-600mm",
  },
  {
    label: "300-700mm",
    value: "300-700mm",
  },
];

export const industryType = [
  {
    label: "Utility",
    value: "Utility",
  },
];

export const projectDuration = [
  {
    label: "10 Year",
    value: "10 Year",
  },
  {
    label: "20 Year",
    value: "20 Year",
  },
  {
    label: "30 Year",
    value: "30 Year",
  },
];

export const userType = {
  // not using currently
  GREEN_CREDIT_DEVELOPER: "Green Credit Project Developer",
  CERTIFIERS: "certifier",
  VERIFIERS: "verifier",
  BUYERS: "buyers",
};

export const stepperConfig: StepperConfig[] = [
  {
    userType: "Implementing Agency",
    devType: "INDIVIDUAL",
    steps: 3,
    stepperData: [
      {
        id: 1,
        isCompleted: true,
        name: "User Type Details",
        isActive: false,
        route: path.onboarding,
      },
      {
        id: 2,
        isCompleted: false,
        name: "Forest Department Details",
        isActive: true,
        route: path.agencyDetails,
      },
      {
        id: 3,
        isCompleted: false,
        name: "Bank Details",
        isActive: false,
        route: path.bankDetails,
      },
      {
        id: 4,
        isCompleted: false,
        name: "Nodal Officer",
        isActive: false,
        route: path.nodalOfficerDetails,
      },
      {
        id: 5,
        isCompleted: false,
        name: "Implementing Officer",
        isActive: false,
        route: path.implementingOfficerDetails,
      },
    ],
  },
  // {
  //   userType: "Registration of Forest Department",
  //   devType: "ORGANIZATION",
  //   steps: 4,
  //   stepperData: [
  //     {
  //       id: 1,
  //       isCompleted: true,
  //       name: "User Details",
  //       isActive: false,
  //       route: path.onboarding,
  //     },
  //     {
  //       id: 2,
  //       isCompleted: false,
  //       name: "Entity Details", // previously It was organisation
  //       isActive: true,
  //       route: path.organizationDetails,
  //     },
  //     {
  //       id: 3,
  //       isCompleted: false,
  //       name: "Document Upload",
  //       isActive: false,
  //       route: path.documentUpload,
  //     },
  //     {
  //       id: 4,
  //       isCompleted: false,
  //       name: "Address Details",
  //       isActive: false,
  //       route: path.addressDetails,
  //     },
  //   ],
  // },
  {
    userType: "Registration of land parcel by Forest Department",
    devType: "INDIVIDUAL",
    steps: 3,
    stepperData: [
      {
        id: 1,
        isCompleted: true,
        name: "User Type Details",
        isActive: false,
        route: path.onboarding,
      },
      {
        id: 2,
        isCompleted: false,
        name: "Personal Details",
        isActive: true,
        route: path.personalDetails,
      },
      {
        id: 3,
        isCompleted: false,
        name: "Aadhaar Verification",
        isActive: false,
        route: path.aadhaarVerification,
      },
      {
        id: 4,
        isCompleted: false,
        name: "Address Details",
        isActive: false,
        route: path.addressDetails,
      },
    ],
  },
  {
    userType: "Registration of land parcel by Forest Department",
    devType: "ORGANIZATION",
    steps: 4,
    stepperData: [
      {
        id: 1,
        isCompleted: true,
        name: "User Details",
        isActive: false,
        route: path.onboarding,
      },
      {
        id: 2,
        isCompleted: false,
        name: "Entity Details", // previously It was organisation
        isActive: true,
        route: path.organizationDetails,
      },
      {
        id: 3,
        isCompleted: false,
        name: "Document Upload",
        isActive: false,
        route: path.documentUpload,
      },
      {
        id: 4,
        isCompleted: false,
        name: "Address Details",
        isActive: false,
        route: path.addressDetails,
      },
    ],
  },
  // {
  //   userType: "Registration of Entity/Private Sector/Philanthropy",
  //   devType: "INDIVIDUAL",
  //   steps: 3,
  //   stepperData: [
  //     {
  //       id: 1,
  //       isCompleted: true,
  //       name: "User Type Details",
  //       isActive: false,
  //       route: path.onboarding,
  //     },
  //     {
  //       id: 2,
  //       isCompleted: false,
  //       name: "Personal Details",
  //       isActive: true,
  //       route: path.personalDetails,
  //     },
  //     {
  //       id: 3,
  //       isCompleted: false,
  //       name: "Aadhaar Verification",
  //       isActive: false,
  //       route: path.aadhaarVerification,
  //     },
  //     {
  //       id: 4,
  //       isCompleted: false,
  //       name: "Address Details",
  //       isActive: false,
  //       route: path.addressDetails,
  //     },
  //   ],
  // },
  {
    userType: "Entity/ Green Credit Applicant",
    devType: "ORGANIZATION",
    steps: 4,
    stepperData: [
      {
        id: 1,
        isCompleted: true,
        name: "User Details",
        isActive: false,
        route: path.onboarding,
      },
      {
        id: 2,
        isCompleted: false,
        name: "Entity Details", // previously It was organisation
        isActive: true,
        route: path.entityDetails,
      },
      {
        id: 3,
        isCompleted: false,
        name: "ID and Documents Upload",
        isActive: false,
        route: path.organizationDetails,
      },
      {
        id: 4,
        isCompleted: false,
        name: "Contact Details",
        isActive: false,
        route: path.contactDetails,
      },
    ],
  },
  {
    userType: "buyers",
    devType: "INDIVIDUAL",
    steps: 3,
    stepperData: [
      {
        id: 1,
        isCompleted: true,
        name: "User Details",
        isActive: false,
        route: path.onboarding,
      },
      {
        id: 2,
        isCompleted: false,
        name: "Personal Details",
        isActive: true,
        route: path.onboarding,
      },
      {
        id: 3,
        isCompleted: false,
        name: "Additional Details",
        isActive: false,
        route: path.onboarding,
      },
    ],
  },
  {
    userType: "buyers",
    devType: "ORGANIZATION",
    steps: 4,
    stepperData: [
      {
        id: 1,
        isCompleted: true,
        name: "User Details",
        isActive: false,
        route: path.onboarding,
      },
      {
        id: 2,
        isCompleted: false,
        name: "Organization Details",
        isActive: true,
        route: path.onboarding,
      },
      {
        id: 3,
        isCompleted: false,
        name: "Additional Details",
        isActive: false,
        route: path.onboarding,
      },
      {
        id: 4,
        isCompleted: false,
        name: "Address Details",
        isActive: false,
        route: path.onboarding,
      },
    ],
  },
];

export enum ProjectType {
  "WATER_CONSERVATION" = "WATER_CONSERVATION",
  "TREE_PLANTATION" = "TREE_PLANTATION",
  "LAND_LEASED" = "LAND_LEASED",
}

export const ROLES = {
  REVIEWER: "Reviewer",
  APPROVER: "Approver",
  INDIVIDUAL: "Individual",
  ENTITY: "Entity",
  ORGANIZATION: "Entity",
};

export enum PROJECT_DOCUMENT_TYPE_MAP {
  SELF_DECLARATION_FORM = "Self declaration form",
  LAND_OWNERSHIP = "Land Ownership",
  PLOT_LAYOUT = "Plot layout",
  AREA_SHAPE = "Area shape",
  PROJECT_LAYOUT = "Project layout",
  BANK_PASSBOOK = "Bank passbook",
  BANK_CHEQUE = "bank cheque",
  BANK_ACCOUNT_RECORD = "Bank account record",
  SAPLING_RECEIPT = "Sapling receipt",
  PAYMENT_RECEIPT = "Payment receipt",
  WORKING_PERMIT = "Working permit",
}

// export enum PROJECT_DOCUMENT_TYPE {
//   SELF_DECLARATION_FORM = "SELF_DECLARATION_FORM",
//   LAND_OWNERSHIP = "LAND_OWNERSHIP",
//   PLOT_LAYOUT = "PLOT_LAYOUT",
//   AREA_SHAPE = "AREA_SHAPE",
//   PROJECT_LAYOUT = "PROJECT_LAYOUT",
//   BANK_PASSBOOK = "BANK_PASSBOOK",
//   BANK_CHEQUE = "BANK_CHEQUE",
//   BANK_ACCOUNT_RECORD = "BANK_ACCOUNT_RECORD",
//   SAPLING_RECEIPT = "SAPLING_RECEIPT",
//   PAYMENT_RECEIPT = "PAYMENT_RECEIPT",
//   WORKING_PERMIT = "WORKING_PERMIT",
// }
//test

export enum ImageType {
  SELF_DECLARATION_FORM = "SELF_DECLARATION_FORM",
  LAND_OWNERSHIP = "LAND_OWNERSHIP",
  PLOT_LAYOUT = "PLOT_LAYOUT",
  AREA_SHAPE = "AREA_SHAPE",
  PROJECT_LAYOUT = "PROJECT_LAYOUT",
  BANK_ACCOUNT_RECORD = "BANK_ACCOUNT_RECORD",
  SAPLING_RECEIPT = "SAPLING_RECEIPT",
  PAYMENT_RECEIPT = "PAYMENT_RECEIPT",
  WORKING_PERMIT = "WORKING_PERMIT",
}

export const organizationOptions: Option[] = [
  {
    label: "Farmer Producer Organisation(FPO)",
    value: "FPO",
  },
  {
    label: "Forest Management Committee(FMC)",
    value: "FMC",
  },
  {
    label: "Joint Forest Management Committee(JFMC)",
    value: "JFMC",
  },
  {
    label: "Self Help Group(SHG)",
    value: "SHG",
  },
  {
    label: "Eco-Development committee(EDC)",
    value: "EDC",
  },
  {
    label: "Urban Local Bodies(ULB)",
    value: "ULB",
  },
  {
    label: "Non-Government Organisation(NGO)",
    value: "NGO",
  },
  {
    label: "Enterprise",
    value: "enterprise",
  },
  {
    label: "Company",
    value: "company",
  },
  {
    label: "Others",
    value: "others",
  },
];

// export const incomeRageOptions = [
//   { label: "4000-5000 lpa", value: "4-5" },
//   { label: "5000-6000 lpa", value: "5-6" },
//   { label: "6000-7000 lpa", value: "6-7" },
// ];
// export const institutionTypeOptions = [
//   { label: "Cooperative", value: "Cooperative" },
//   { label: "fp", value: "fp" },
//   { label: "FMC", value: "FMC" },
//   { label: "SHGs", value: "SHGs" },
//   { label: "Eco-development committee", value: "Eco-development" },
//   { label: "Urban", value: "Urban" },
//   { label: "rural", value: "rural" },
// ];
// export const stateOptions = [
//   { label: "delhi", value: "delhi" },
//   { label: "haryana", value: "haryana" },
//   { label: "up", value: "up" },
// ];

export const ladUseTypeOption = [
  { label: "agricultural", value: "agricultural" },
  { label: "urban ", value: "urban " },
  { label: "rural", value: "rural" },
];

export const genderTypeOptions = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
];

export const activityPurposeOptions = [
  { label: "Compliance", value: DECLERATION_TYPE.COMPLIANCE },
  { label: "Voluntary", value: DECLERATION_TYPE.VOLUNTARY },
  {
    label: "Accredited Compensatory Afforestation (ACA)",
    value: DECLERATION_TYPE.ACA,
  },
];
export const landTypeOptions = [
  { label: "Degraded Forest Land", value: "Degraded Forest Land" },
  { label: "Watershed areas", value: "Watershed areas" },
  { label: "Waste Land", value: "Waste Land" },
  { label: "Community Land", value: "Community Land" },
  {
    label: "Owned by Individuals/Organisations",
    value: "Owned by Individuals/Organisations",
  },
];

export const tooltipContent = {
  reject: {
    title: "Reason For Rejection",
    desc: "Lorem ipsum dolor sit amet consectetur. Adipiscing molestie duis leo tortor tellus.",
  },
};

export const homeTabs = [
  {
    label: "Plantation Block",
    value: ProjectType.TREE_PLANTATION,
    type: "Entity/ Green Credit Applicant",
  },
  {
    label: "Land Parcel",
    value: ProjectType.LAND_LEASED,
    type: "Implementing Agency",
  },
];

export const RoleIds = {
  "Green Credit Project Developer": "b9c4e0f5-c062-4ad5-9cb3-fc3e24e918c1",
  Approver: "36a8cd90-9fa4-4c08-ab8f-f8faf96c64f1",
  Reviewer: "bf03a589-86c0-4f1f-be20-9ebec7c7d800",
};

export const registeredLandTabs = [
  {
    label: "Registered",
    value: undefined,
  },
  {
    label: "SNO Verification",
    value: "NODAL_VERIFICATION_PENDING",
  },
  {
    label: "Admin Verification",
    value: "VERIFICATION_PENDING",
  },
  { label: "SNO Query", value: "NODAL_UNDER_QUERY" },
  { label: "Admin Query", value: "UNDER_QUERY" },
  { label: "Approved", value: "APPROVED" },
  { label: "Rejected", value: "REJECTED" },
  { label: "Withdrawal Block", value: "WITHDRAWN" },
  { label: "Approved under old OM", value: "OLD_APPROVED" },
];

export const entityTabs = [
  {
    label: "All",
    value: undefined,
  },
  {
    label: "Demand Note Pending",
    value:
      "REGENERATE_DEMAND_NOTE,GENERATE_DEMAND_NOTE,VERIFY_DEMAND_NOTE,UNDER_QUERY,NODAL_UNDER_QUERY,NODAL_VERIFY_DEMAND_NOTE",
  },
  {
    label: "Payment Pending",
    value: "PAYMENT_PENDING",
  },
  { label: "Payment Under Verification", value: "VERIFICATION_PENDING" },
  { label: "Payment Approved", value: "APPROVED" },
  { label: "Deselect", value: "DESELECT" },
];

export const registeredEntitiesTabs = [
  {
    label: "All",
    value: undefined,
  },
  {
    label: "Cost Estimate Pending",
    value: "GENERATE_DEMAND_NOTE,REGENERATE_DEMAND_NOTE",
  },
  {
    label: "SNO Verification",
    value: "NODAL_VERIFY_DEMAND_NOTE",
  },
  {
    label: "Admin Verification",
    value: "VERIFY_DEMAND_NOTE",
  },
  { label: "SNO Query", value: "NODAL_UNDER_QUERY" },
  { label: "Admin Query", value: "UNDER_QUERY" },
  { label: "Payment Pending", value: "PAYMENT_PENDING" },
  {
    label: "Payment Received By Admin",
    value: "APPROVED,VERIFICATION_PENDING",
  },
  {
    label: "Deselected",
    value: "DESELECT",
  },
];

export const selectedProvisionalTabs = [
  {
    label: "All",
    value: undefined,
  },
  {
    label: "Provisionally Selected",
    value: "PROVISIONAL_SELECTED",
  },
  {
    label: "Site Visit",
    value: "SITE_VISITED",
  },
  {
    label: "Acknowledgment Issued",
    value: "ACKNOWLEDGE_BY_APPROVER",
  },
  {
    label: "Rejected",
    value: "DESELECT",
  },
];

export const detailedProjectAllTabValue =
  "ACKNOWLEDGE_BY_APPROVER,DPR_DRAFT,DPR_SUBMIT,DPR_DNO_QUERY,DPR_UNDER_SNO,DPR_SNO_QUERY,DPR_UNDER_ADMIN,DPR_ADMIN_QUERY,DPR_APPROVED,DPR_REJECTED,DPR_DESELECT";

export const detailedProjectWithoutDeselected =
  "ACKNOWLEDGE_BY_APPROVER,DPR_DRAFT,DPR_SUBMIT,DPR_DNO_QUERY,DPR_UNDER_SNO,DPR_SNO_QUERY,DPR_UNDER_ADMIN,DPR_ADMIN_QUERY,DPR_APPROVED,DPR_REJECTED,DPR_DESELECT";

export const dprStatusMessages: Record<string, string> = {
  DPR_DRAFT: "Draft",
  DPR_SUBMIT: "Submitted",
  DPR_DNO_QUERY: "Query from DNO",
  DPR_UNDER_SNO: "Under SNO",
  DPR_SNO_QUERY: "Query from SNO",
  DPR_UNDER_ADMIN: "Under Admin",
  DPR_ADMIN_QUERY: "Query from Admin",
  DPR_APPROVED: "Approved",
  DPR_REJECTED: "Rejected",
  DPR_DESELECT: "Deselected",
  ACKNOWLEDGE_BY_APPROVER: "Pending Upload",
};

export const detailedProjectTabs = [
  {
    label: "All",
    value: detailedProjectWithoutDeselected,
  },
  {
    label: "DPR Pending",
    value: "ACKNOWLEDGE_BY_APPROVER,DPR_DRAFT",
  },
  {
    label: "DPR under DNO",
    value: "DPR_SUBMIT",
  },
  {
    label: "Query from DNO",
    value: "DPR_DNO_QUERY",
  },
  {
    label: "DPR under SNO",
    value: "DPR_UNDER_SNO",
  },
  {
    label: "Query from SNO",
    value: "DPR_SNO_QUERY",
  },
  {
    label: "DPR under Admin",
    value: "DPR_UNDER_ADMIN",
  },
  {
    label: "Query from Admin",
    value: "DPR_ADMIN_QUERY",
  },
  {
    label: "DPR Approved",
    value: "DPR_APPROVED",
  },
  {
    label: "Rejected",
    value: "DPR_REJECTED",
  },
  {
    label: "Deselect",
    value: "DPR_DESELECT",
  },
];

export const memorandumTab = [
  {
    label: "All",
    value:
      "MOU_SUBMIT,MOU_DNO_QUERY,MOU_UNDER_SNO,MOU_SNO_QUERY,MOU_UNDER_ADMIN,MOU_ADMIN_QUERY,MOU_APPROVED",
  },
  {
    label: "MOU Submitted",
    value: "MOU_SUBMIT",
  },
  {
    label: "Query from DNO",
    value: "MOU_DNO_QUERY",
  },
  {
    label: "MOU under SNO",
    value: "MOU_UNDER_SNO",
  },
  {
    label: "Query from SNO",
    value: "MOU_SNO_QUERY",
  },
  {
    label: "MOU under Admin",
    value: "MOU_UNDER_ADMIN",
  },
  {
    label: "Query from Admin",
    value: "MOU_ADMIN_QUERY",
  },
  {
    label: "MOU Approved",
    value: "MOU_APPROVED",
  },
];

/**
 * Display name for each fund application status. Tab labels below mirror these,
 * so the tab a row lives under always reads the same as its Status cell.
 */
export const fundStatus: Record<string, string> = {
  CREATED: "Pending With SNO",
  RAISED: "Pending With Admin",
  NODAL_UNDER_QUERY: "Under SNO Query",
  UNDER_QUERY: "Under Admin Query",
  APPROVED: "Fund Released",
  PAYMENT_ACKNOWLEDGED: "Payment Receipt Uploaded",
  UC_UPLOADED: "UC Uploaded",
  UC_APPROVED: "UC Accepted",
  UC_REJECTED: "UC Rejected",
  REJECTED: "FA Rejected",
};

/** The user type a fund application sits with while it is in a given status. */
export type FundActionActor = "SNO" | "IMPLEMENTING_OFFICER" | "ADMIN";

/**
 * The single action available on a fund application in each status, and the
 * user type it is visible to. Every other user sees an empty Action cell —
 * the status itself is still shown to everyone. Kept in sync with the admin
 * portal's copy of this map.
 */
export const fundActionByStatus: Record<
  string,
  { label: string; actor: FundActionActor }
> = {
  CREATED: { label: "Upload Fund Application", actor: "SNO" },
  NODAL_UNDER_QUERY: { label: "Reply Query", actor: "IMPLEMENTING_OFFICER" },
  RAISED: { label: "Release Fund", actor: "ADMIN" },
  UNDER_QUERY: { label: "Reply Query", actor: "SNO" },
  // Fund released: the SNO normally uploads the payment receipt here, but the
  // UC form is open at this stage too, so the one cell offers both.
  APPROVED: { label: "Upload Payment Receipt/UC", actor: "SNO" },
  PAYMENT_ACKNOWLEDGED: { label: "Upload UC", actor: "SNO" },
  UC_UPLOADED: { label: "Verify UC", actor: "ADMIN" },
  UC_REJECTED: { label: "Re-upload UC", actor: "SNO" },
  UC_APPROVED: {
    label: "Raise New Fund Application",
    actor: "IMPLEMENTING_OFFICER",
  },
};

export const fundPaymentTabs = [
  {
    label: "All",
    value: undefined,
  },
  {
    label: "Pending With SNO",
    value: "CREATED",
  },
  {
    label: "Pending With Admin",
    value: "RAISED",
  },
  {
    label: "Under SNO Query",
    value: "NODAL_UNDER_QUERY",
  },
  {
    label: "Under Admin Query",
    value: "UNDER_QUERY",
  },
  {
    label: "Fund Released",
    value: "APPROVED",
  },
  {
    label: "Payment Receipt Uploaded",
    value: "PAYMENT_ACKNOWLEDGED",
  },
  {
    label: "UC Uploaded",
    value: "UC_UPLOADED",
  },
  {
    label: "UC Accepted",
    value: "UC_APPROVED",
  },
  {
    label: "UC Rejected",
    value: "UC_REJECTED",
  },
];

export const fundPaymentTabsIO = [
  {
    label: "All",
    value: undefined,
  },
  {
    label: "Pending With SNO",
    value: "CREATED",
  },
  {
    label: "Pending With Admin",
    value: "RAISED",
  },
  {
    label: "Under SNO Query",
    value: "NODAL_UNDER_QUERY",
  },
  {
    label: "Under Admin Query",
    value: "UNDER_QUERY",
  },
  {
    label: "Fund Released",
    value: "APPROVED",
  },
  {
    label: "UC Uploaded",
    value: "UC_UPLOADED",
  },
  {
    label: "UC Accepted",
    value: "UC_APPROVED",
  },
  {
    label: "UC Rejected",
    value: "UC_REJECTED",
  },
];

export const fundPaymentEntityTabs = [
  {
    // Covers both APPROVED and PAYMENT_ACKNOWLEDGED for the entity view.
    label: "Fund Released",
    value: "APPROVED,PAYMENT_ACKNOWLEDGED",
  },
  {
    label: "UC Uploaded",
    value: "UC_UPLOADED",
  },
  {
    label: "UC Accepted",
    value: "UC_APPROVED",
  },
  {
    label: "UC Rejected",
    value: "UC_REJECTED",
  },
];

export const costEstimateDetails = [
  {
    label: "All",
    value: undefined,
  },
  {
    label: "Save & Draft",
    value: "DRAFT",
  },
  {
    label: "Submitted",
    value: "SUBMIT_TO_SNO,SUBMIT_TO_ADMIN",
  },
  {
    label: "Under Query",
    value: "UNDER_QUERY",
  },
];

export const statusMessages = {
  UNDER_QUERY: "Under Query",
  GENERATE_DEMAND_NOTE: "Generate Estimated Amount",
  REGENERATE_DEMAND_NOTE: "Regenerate Estimated Amount",
};

export const statusMessages2 = {
  UNDER_QUERY: "ADMIN QUERY",
  VERIFY_DEMAND_NOTE: "UNDER VERIFICATION",
  GENERATE_DEMAND_NOTE: "COST ESTIMATE PENDING",
  REGENERATE_DEMAND_NOTE: "RESUBMIT COST ESTIMATE",
  NODAL_VERIFY_DEMAND_NOTE: "SNO VERIFICATION PENDING",
  NODAL_UNDER_QUERY: "SNO QUERY",
  PAYMENT_PENDING: "PAYMENT PENDING",
};

export const entityStatusMessages = {
  UNDER_QUERY: "Cost Est. Under Query",
  NODAL_VERIFY_DEMAND_NOTE: "Cost Est. Pending",
  NODAL_UNDER_QUERY: "Cost Est. Pending",
  GENERATE_DEMAND_NOTE: "Cost Est. Pending",
  REGENERATE_DEMAND_NOTE: "Cost Est. Pending",
  VERIFY_DEMAND_NOTE: "Cost Est. Under Verfication",
  APPROVED: "Payment Done",
  DPR_DESELECT: "Deselected",
};

export const units = [
  {
    label: "Kg",
    value: "Kg",
  },
  {
    label: "No`s",
    value: "No`s",
  },
  {
    label: "No`s/Ha",
    value: "No`s/Ha",
  },
  {
    label: "m",
    value: "m",
  },
  {
    label: "Mandays",
    value: "Mandays",
  },
  {
    label: "Ha",
    value: "Ha",
  },
  {
    label: "RMTs",
    value: "RMTs",
  },
  {
    label: "Lump Sum(LS)",
    value: "Lump Sum(LS)",
  },
  {
    label: "cm",
    value: "cm",
  },
  {
    label: "Per Plant",
    value: "Per Plant",
  },
  {
    label: "Per Ha",
    value: "Per Ha",
  },
];

export const calenderYear = [
  {
    label: "2024-2025",
    value: "2024-2025",
  },
  {
    label: "2025-2026",
    value: "2025-2026",
  },
  {
    label: "2026-2027",
    value: "2026-2027",
  },
  {
    label: "2027-2028",
    value: "2027-2028",
  },
  {
    label: "2028-2029",
    value: "2028-2029",
  },
  {
    label: "2029-2030",
    value: "2029-2030",
  },
  {
    label: "2030-2031",
    value: "2030-2031",
  },
  {
    label: "2031-2032",
    value: "2031-2032",
  },
  {
    label: "2032-2033",
    value: "2032-2033",
  },
  {
    label: "2033-2034",
    value: "2033-2034",
  },
  {
    label: "2034-2035",
    value: "2034-2035",
  },
  {
    label: "2035-2036",
    value: "2035-2036",
  },
];

export const year = [
  {
    label: "1st Year",
    value: "1st Year",
  },
  {
    label: "2nd Year",
    value: "2nd Year",
  },
  {
    label: "3rd Year",
    value: "3rd Year",
  },
  {
    label: "4th Year",
    value: "4th Year",
  },
  {
    label: "5th Year",
    value: "5th Year",
  },
  {
    label: "6th Year",
    value: "6th Year",
  },
  {
    label: "7th Year",
    value: "7th Year",
  },
  {
    label: "8th Year",
    value: "8th Year",
  },
  {
    label: "9th Year",
    value: "9th Year",
  },
  {
    label: "10th Year",
    value: "10th Year",
  },
  {
    label: "Other Necessary Provisions",
    value: "Other Necessary Provisions",
  },
];

export const AUTOCOMPLETE_OPTION = [
  {
    label: "Fencing Operations",
    value: "Fencing",
  },
  {
    label: "Nursery Operations",
    value: "Nursery",
  },
  {
    label: "Land Preparation Activities",
    value: "Land-Preparation",
  },
  {
    label: "Planting Operations",
    value: "Plantation",
  },
  {
    label: "Eco Restoration Operations",
    value: "smc",
  },
  {
    label: "Irrigation Measures",
    value: "Irrigation",
  },
  {
    label: "Protection And Maintenance",
    value: "Protection",
  },
  {
    label: "Others",
    value: "Others",
  },
  {
    label: "Plantation Journal",
    value: "Plantation-Journal",
  },
];

export const MONTHS = [
  {
    label: "1st Monitoring",
    value: "1st Monitoring",
  },
  {
    label: "2nd Monitoring",
    value: "2nd Monitoring",
  },
];
export enum ENUM_MONITORING_TYPE {
  PLANTATION = "PLANTATION",
  FENCING = "FENCING",
  LAND_PREPARATION = "LAND_PREPARATION",
  SMC = "SMC",
  IRRIGATION = "IRRIGATION",
  NURSERY = "NURSERY",
  PROTECTION = "PROTECTION",
  PLANTATION_JOURNAL = "PLANTATION_JOURNAL",
  OTHER = "OTHER",
  SUBMIT = "FINAL_SUBMIT",
}

export const FENCING_TYPE: Option[] = [
  {
    label: "Chain link fencing",
    value: "Chain link fencing",
  },
  {
    label: "Barbed wire fencing",
    value: "Barbed wire fencing",
  },
  {
    label: "Stone wall fencing",
    value: "Stone wall fencing",
  },
  {
    label: "Trench fencing",
    value: "Trench fencing",
  },
  {
    label: "Pucca wall construction",
    value: "Pucca wall construction",
  },
  {
    label: "Thorn fencing",
    value: "Thorn fencing",
  },
  {
    label: "Loose stone fencing",
    value: "LOOSE_STONE_FENCING ",
  },
  {
    label: "New ditch fencing",
    value: "NEW_DITCH_FENCING",
  },
  {
    label: "Others (if any)",
    value: "OTHERS",
  },
];

export const IRRIGATION_TYPE = [
  {
    value: "Tube Well",
    label: "Tube Well",
  },
  {
    value: "Solar Tube Well",
    label: "Solar Tube Well",
  },
  {
    value: "Tanker",
    label: "Tanker",
  },
  {
    value: "Pond",
    label: "Pond",
  },
  {
    value: "Others",
    label: "Others",
  },
];

export const IRRIGATION_STATUS_TYPE: Option[] = [
  {
    label: "In Good Condition",
    value: "In Good Condition",
  },
  {
    label: "Need Repair",
    value: "Need Repair ",
  },
  {
    label: "Defunct",
    value: "Defunct",
  },
];

export const SIGNBOARD_TYPE: Option[] = [
  {
    label: "Cemented",
    value: "Cemented",
  },
  {
    label: "Iron",
    value: "Iron",
  },
  {
    label: "Others",
    value: "Others",
  },
];

export const KUTIR_TYPE: Option[] = [
  {
    label: "Pakka",
    value: "Pakka",
  },
  {
    label: "Kachcha",
    value: "Kachcha",
  },
];

export const KUTIR_MAINTENANCE_TYPE: Option[] = [
  {
    label: "Maintained",
    value: "Maintained",
  },
  {
    label: "Not Maintained",
    value: "Not Maintained",
  },
];

export const VANKUTIR_STATUS_TYPE: Option[] = [
  {
    label: "In Good Condition",
    value: "In Good Condition",
  },
  {
    label: "Need Repair",
    value: "Need Repair ",
  },
  {
    label: "Defunct",
    value: "Defunct",
  },
];

export const WATER_HARVESTING_STRUCTURE_TYPE: Option[] = [
  {
    label: "Gabbiaon Structure",
    value: "Gabbiaon Structure",
  },
  {
    label: "Check Dam",
    value: "Check Dam",
  },
  {
    label: "Earthen Dam",
    value: "Earthen Dam",
  },
];

export const RATINGS = [
  {
    label: "1",
    value: "1",
  },
  {
    label: "2",
    value: "2",
  },
  {
    label: "3",
    value: "3",
  },
  {
    label: "4",
    value: "4",
  },
  {
    label: "5",
    value: "5",
  },
  {
    label: "6",
    value: "6",
  },
  {
    label: "7",
    value: "7",
  },
  {
    label: "8",
    value: "8",
  },
  {
    label: "9",
    value: "9",
  },
  {
    label: "10",
    value: "10",
  },
];
